import { useEffect, useReducer } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { useFlags } from "launchdarkly-react-client-sdk";
import { getEnvConfig } from "helpers/environment-config";

import "./styles.css";

const buttonContainerId = "comm100-button-78e1870f-6611-4eb6-af83-e9ba4fa1778b";
const chatContainerId = "comm100-container";

let readyResolver;
const readyPromise = new Promise((resolve) => (readyResolver = resolve));

const initComm100Chat = async () => {
  const env = await getEnvConfig("environment");
  if (env === "development") {
    return;
  }

  // adapted chat installation script
  window.Comm100API = window.Comm100API || {};
  (function (Comm100) {
    const buttonContainer = document.createElement("div");
    buttonContainer.id = buttonContainerId;
    document.body.appendChild(buttonContainer);

    function loadScript(baseUrl) {
      const script = document.createElement("script");
      const anchorScript = document.getElementsByTagName("script")[0];

      script.type = "text/javascript";
      script.async = true;
      script.src = baseUrl + Comm100.site_id;

      anchorScript.parentNode.insertBefore(script, anchorScript);
    }

    Comm100.chat_buttons = Comm100.chat_buttons || [];
    Comm100.chat_buttons.push({
      code_plan: "78e1870f-6611-4eb6-af83-e9ba4fa1778b",
      div_id: buttonContainerId
    });

    Comm100.site_id = 70001608;
    Comm100.main_code_plan = "78e1870f-6611-4eb6-af83-e9ba4fa1778b";

    Comm100.onReady = readyResolver;

    loadScript("https://vue.comm100.com/livechat.ashx?siteId=");

    setTimeout(function () {
      if (!Comm100.loaded) {
        loadScript("https://standby.comm100vue.com/livechat.ashx?siteId=");
      }
    }, 5000);
  })(window.Comm100API);
};

void initComm100Chat();

const showComm100ChatElements = (...elements) => {
  elements.forEach(element => {
    if (element) {
      element.style.setProperty("display", "block", "important");
    }
  });
};

const hideComm100ChatElements = (...elements) => {
  elements.forEach(element => {
    if (element) {
      element.style.removeProperty("display");
    }
  });
};

const Comm100Chat = ({ authentication }) => {
  const { bar947EnableLiveChat } = useFlags();

  const forceUpdate = useReducer(() => ({}), {})[1];

  useEffect(() => {
    readyPromise.then(forceUpdate);
  }, []);

  useEffect(() => {
    if (authentication.user && (bar947EnableLiveChat || authentication.isSystemAdmin)) {
      showComm100ChatElements(document.getElementById(buttonContainerId), document.getElementById(chatContainerId));
    } else {
      hideComm100ChatElements(document.getElementById(buttonContainerId), document.getElementById(chatContainerId));
    }
  }, [authentication, bar947EnableLiveChat]);

  return null;
};

const mapStateToProps = ({ authentication }) => ({ authentication });

export default compose(connect(mapStateToProps))(Comm100Chat);
